import { UserType } from '@quipex/shared/contracts';
import { DOCUMENT_TOPICS } from './document-suggestion-topics';
import type { QuippySuggestedQuestion } from './models';
import { PACK_TOPICS } from './pack-suggestion-topics';
import { CATEGORY_ICONS } from './personas/models';

export type QuippySuggestionOutcome = 'find' | 'pack';

export function getQuippyOutcomeSuggestions(
    outcome: QuippySuggestionOutcome,
    scope: 'building' | 'portfolio',
    userType: UserType | undefined
): readonly QuippySuggestedQuestion[] {
    if (outcome === 'pack' && scope === 'portfolio') {
        return [];
    }
    const persona =
        userType !== undefined && Object.hasOwn(DOCUMENT_TOPICS, userType)
            ? userType
            : UserType.Other;
    const category = outcome === 'find' ? 'Find evidence' : 'Plan change';
    const context = scope === 'building' ? 'this building' : 'my portfolio';
    const complete =
        outcome === 'find'
            ? DOCUMENT_TOPICS[persona].map(
                  (topic) => `Find ${topic} for ${context}.`
              )
            : PACK_TOPICS[persona].map(
                  (topic) =>
                      `Help me prepare a document pack for ${topic} at this building.`
              );
    const editable =
        outcome === 'find'
            ? DOCUMENT_TOPICS[persona]
                  .slice(0, 2)
                  .map((topic) => `Find ${topic} for ${context} relating to…`)
            : PACK_TOPICS[persona]
                  .slice(0, 2)
                  .map(
                      (topic) =>
                          `Help me prepare a document pack for ${topic} at this building, including…`
                  );
    return [...complete, ...editable].map((text, index) => ({
        id: `${scope}-${persona}-${outcome}-${index}`,
        text,
        category,
        icon: CATEGORY_ICONS[category],
        action: index < complete.length ? 'submit' : 'prefill',
    }));
}
